import React, {useState, useEffect} from 'react';
import Button from '../../Form/Button/Button';
import NoticeAccountClosureModal from './NoticeAccountClosureModal'

import './accountClosure.scss';

/** @import {NoticeAccountClosureProps} from './NoticeAccountClosureTypes' */

const shouldDisableButton = (/** @type {string} */ status) => {
    if (status === "ClosureRequested" || status === "Closed")
        return true;

    return false;
};

function NoticeAccountClosure(/** @type {NoticeAccountClosureProps} */ props) {
    const [modalVisible, setModalVisible] = useState(false);
    const [disable, setDisable] = useState(shouldDisableButton(props.accountStatus));

    useEffect(() => {
        if (modalVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [modalVisible]);
    
    const onCancel = () => {
        setModalVisible(false);
    }

    const onClosed = () => {
        setDisable(true);
        setModalVisible(false);
    }

    return (
        <>
            <Button
                size='med'
                label={`Close my ${props.productName}`}
                onClick={() => setModalVisible(true)}
                disabled={disable} />
            
            {modalVisible && <NoticeAccountClosureModal
                onClosed={onClosed}
                onCancel={onCancel}
                destinationAccounts={props.destinationAccounts}
                productName={props.productName}
                mobileNumber={props.mobileNumber}
                accountId={props.accountId}
                accountStatus={props.accountStatus}
            />}
        </>
    );
};


export default NoticeAccountClosure;